import React from 'react';

import { UiButton } from './ui-button';

type InputProps = {
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
  selected?: boolean;
  className?: string;
  style?: Record<string, any>;
  disabled?: boolean;
};

export const UiFilterToggle = ({
  className,
  style,
  label,
  value,
  onChange,
  selected,
  disabled,
}: InputProps) => {
  const handleChange = () => {
    onChange(!value);
  };

  return (
    <UiButton
      className={className}
      style={style}
      size="xs"
      variant="tertiary"
      onClick={handleChange}
      selected={selected}
      disabled={disabled}
    >
      {label}
    </UiButton>
  );
};
